import React from "react";

export class NotFoundPage extends React.Component{
    constructor(){
        super();
    }
    componentDidMount(){
        window.scrollTo(0, 0);
    }
    render(){
        return (
            <div className="learn-page-container">
                <h1>Page Not Found.</h1>
            </div>
        )
    }
}